import ActionFactory from "./action-factory";
import {Variable} from "shared";

class Action {
    type;
    startTime;
    className;
    actionId;

    constructor({type, startTime, className = 'default', actionId}) {
        this.type = type;
        this.startTime = startTime || 0;
        this.className = className;
        this.actionId = actionId ? actionId : generateUUID();
    }

    static async parseValue(value, eventLoop) {
        if (typeof value !== "string") {
            return value;
        }

        value = value.trim();

        if (value.startsWith("=>")) {
            // Not working
            const textScript = eventLoop.training.textScript;
            return await textScript.run(value.slice(2), {
                executeAction: eventLoop.executeAction.bind(eventLoop),
                createAction: ActionFactory.create.bind(ActionFactory),
                getModelNameFromID : eventLoop.getModelNameFromID.bind(eventLoop)
            });
        } else {
            return value;
        }
    }

    async execute() {
        throw new Error("subclass responsibility");
    }

    async stop() {
        //do nothing by default
    }

    cancel() {
        throw new Error("subclass responsibility");
    }

    interpolateVariableValues(training, text = "") {
        if (!text) return text;

        const registry = training.registry;
        //match variables with the pattern $(variableName) and catch them as group
        const variablePattern = new RegExp("(\\$\\(" + Variable.variableNamePattern + "\\))", "gm");
        const matches = [...text.matchAll(variablePattern)];
        if (matches.length <= 0) {
            return text;
        }

        const textChars = text.split("");
        let indexLeftShift = 0;
        for (let match of matches) {
            const variableName = match[2];
            const variableValue = registry.get(variableName);
            const variableLengthWithDelimiter = match[0].length;
            textChars.splice(match.index - indexLeftShift, variableLengthWithDelimiter, `${variableValue}`);
            indexLeftShift += variableLengthWithDelimiter - 1;
        }

        return textChars.join("");
    }
}

export default Action;
